import * as tokens from '../styles/tokens'

const theme = {
  primary: tokens.primary,
  text: tokens.onSurface,
  labelText: tokens.onSurfacePlaceholder,
  background: tokens.surfaceBright,
  border: tokens.outline,
  offset: tokens.surface,
  hover: tokens.surfaceBrightHover,
  banner: tokens.surfaceDisabled,
  highlight: tokens.primary,
  mutedText: tokens.onSurface,
  invertedText: tokens.onPrimary,
  disabledText: tokens.onSurfaceDisabled,
  linkText: tokens.primary,
  surfaceDim: tokens.surfaceDim,
  hairline: tokens.hairline,
  rowHover: tokens.rowHoverBackground,
  mainMenu: {
    background: tokens.mainMenuBackgroundLight,
  },
  dialog: {
    background: tokens.dialogBackground,
  },
  syntax: tokens.syntax,
}

export type Theme = typeof theme

export default theme
